<template>
  <div>
    <b-container>
      <div v-if="showoverlay" style="z-index: 999; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <b-spinner style="width: 3rem; height: 3rem;" label="Please wait..."></b-spinner>
      </div>
      <b-overlay class="overspin" :show="showoverlay" rounded="sm" fixed>
        <b-row class="mt-3"><b-col><h2>Balance Enquiry</h2></b-col></b-row>

        <b-row class="mt-2"><b-col>Enter the Card / Account number here:</b-col></b-row>
        <b-row class="mt-1">
          <b-col>
            <b-form-input v-model="balEnqAccNo" placeholder="Card Number"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <b-button variant="outline-primary" @click="giftCardBalanceCheck()">Check</b-button>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            Balance for {{ balEnqAccNo }}: {{ gcBalance | toCurrency }}
          </b-col>
        </b-row>

        <b-row class="mt-3"><b-col><h2>Change Account Balance</h2></b-col></b-row>
        <b-row class="mt-2">
          <b-col cols="9">Enter the Card / Account number here:</b-col>
          <b-col cols="3">Amount:</b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col cols="9">
            <b-form-input v-model="topUpAccNo" placeholder="Card Number"></b-form-input>
          </b-col>
          <b-col cols="3">
            <b-form-input v-model="topUpAmount" type="number" step="0.01" placeholder="0.00"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <b-button variant="outline-primary" @click="adjustGiftCardBalance()">Update</b-button>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            Balance for {{ topUpAccNo }}: {{ gcBalance | toCurrency }}
          </b-col>
        </b-row>

      </b-overlay>
    </b-container>
  </div>
</template>

<script>

export default {
  name: "GiftCards",
  data() {
    return {
      showoverlay: false,
      current_location: 0,
      balEnqAccNo: '',
      gcBalance: 0,
      topUpAccNo: '',
      topUpAmount: ''
    }
  },

  created() {
    this.fetchLocations()
  },

  methods: {
    switchOverlay(bool) {
      this.showoverlay = bool;
    },

    async fetchLocations() {
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get("locations", {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      try {
        const sortedlocations = await data.locations.sort((a,b) => a.id - b.id);
        this.current_location = await sortedlocations[0].id;
      } catch(e) {
        console.log(e);
      } finally {
        this.showoverlay = false;
      }
    },

    async giftCardBalanceCheck() {
      this.showoverlay = true;
      // Use Axios to make a call to the API
      const { data } = await this.$api.get("locations/"+this.current_location+"/gift-card-balance?accno="+this.balEnqAccNo );
      try {
        if (data.ecardsys_response=='Succeeded') {
          this.gcBalance = await data.balance;
        } else {
          this.makeToast()
        }
      } catch(e) {
        console.log(e);
      } finally {
        this.showoverlay = false;
      }
    },

    async adjustGiftCardBalance() {
      const token = await this.$auth.getTokenSilently();
      var config = { headers: { Authorization: `Bearer ${token}` } };
      var body = {
        "accno": this.topUpAccNo,
        "topup": this.topUpAmount
      }
      const { data } = await this.$api.post("locations/"+this.current_location+"/gift-card-balance",
        body,
        config
      );
      try {
        if (data.ecardsys_response=='Succeeded') {
          this.gcBalance = await data.balance;
        } else {
          this.makeToast()
        }
      } catch(e) {
        console.log(e);
      } finally {
        this.showoverlay = false;
      }
    },

    makeToast() {
      this.$bvToast.toast('We were not able to complete the request for some reason. Please check the Card Number and try again!', {
        title: `Something went wrong!`,
        variant: "danger",
        solid: true
      })
    }

  },
}
</script>
<style>
  .onboard {
    width: 70%;
    margin: auto;
    text-align: center;
  }
</style>
